<section class="card-section">
  <div class="card">
    <ng-content></ng-content>
    <ng-container *ngIf="showCopyright">
      <div *ifMedia="'desktop'" class="copyright text-grey60">
        © {{ currentYear }} {{ tenantConfigService.config.companyName }} All Rights Reserved
      </div>
    </ng-container>
  </div>
</section>
